import { supabase } from '@/lib/supabase';

export const ORG_ID = '00000000-0000-0000-0000-000000000001';

export interface Organisation {
  id: string;
  raison_sociale: string;
  forme_juridique: string | null;
  siren: string;
  siret_siege: string;
  tva_intracom: string | null;
  naf: string | null;
  rcs: string | null;
  capital_social: string | null;
  adresse_ligne1: string | null;
  adresse_ligne2: string | null;
  code_postal: string | null;
  ville: string | null;
  telephone: string | null;
  email: string | null;
  site_web: string | null;
  decennale_compagnie: string | null;
  decennale_numero_police: string | null;
  decennale_zone_couverture: string | null;
  iban: string | null;
  bic: string | null;
  logo_url: string | null;
  couleur_primaire: string | null;
  couleur_secondaire: string | null;
}

export async function getOrganisation(): Promise<Organisation> {
  const { data, error } = await supabase.from('organizations').select('*').eq('id', ORG_ID).single();
  if (error) throw new Error(error.message);
  return data as Organisation;
}

// Met à jour l'apparence (couleurs de marque + logo). Le logo est stocké en
// data-URL dans `logo_url` (pas de bucket de stockage requis) ; il alimente
// l'en-tête de l'app et les PDF (devis / factures).
export async function updateApparence(input: {
  couleur_primaire: string;
  couleur_secondaire: string;
  logo_url: string | null;
}): Promise<void> {
  const { error } = await supabase
    .from('organizations')
    .update({
      couleur_primaire: input.couleur_primaire,
      couleur_secondaire: input.couleur_secondaire,
      logo_url: input.logo_url,
    })
    .eq('id', ORG_ID);
  if (error) throw new Error(error.message);
}
